import React, { useRef } from 'react';
import { Button, Input, Typography } from '@material-ui/core';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';

export default function FileUpload({
  onFileSelect = () => {},
  acceptedTypes = ['.csv'],
  helpText = '',
  buttonText = 'Upload CSV',
  buttonIcon = <CloudUploadIcon />,
  disabled = false
}) {
  const fileInputRef = useRef(null);

  const handleFileSelect = (event) => {
    const file = event.target.files?.[0];
    if (file) {
      console.log('Selected file:', file.name);
      // handle your CSV upload here
      onFileSelect(file);
    }
  };

  const handleButtonClick = () => {
    if (!fileInputRef.current) return;
    fileInputRef.current.click();
  };

  return (
    <div style={{ marginBottom: 16 }}>
      <input
        type="file"
        accept={acceptedTypes.join(',')}
        ref={fileInputRef}
        onChange={handleFileSelect}
        style={{ display: 'none' }}
      />
      <Button
        variant="contained"
        color="primary"
        onClick={handleButtonClick}
        startIcon={buttonIcon}
        disabled={disabled}
      >
        {buttonText}
      </Button>
      {helpText && (
        <Typography variant="caption" display="block" style={{ marginTop: 8 }}>
          {helpText}
        </Typography>
      )}
    </div>
  );
}
